import { createNotificationComponent, INotificationProperties } from '@vfde-brix/notification';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { NotificationType } from 'Constant';

/**
 * Export mountNotification
 *
 * @export mountNotification
 */
export const mountNotification = (target, title, txtContent, type: NotificationType) => {

    const props: INotificationProperties = {
        txtContent,
        stdTitle: title,
        optHidden: false,
        optType: type,
        business: NO_PATTERN_BUSINESS_LOGIC,
    };

    return createNotificationComponent(target, props);
};
